import { useEffect, useState } from "react";
import { isMobileDevice } from "../../utils/getPlatformInfo";
import styles from "./index.module.scss";

function AnimatedHeader({
  mainHeader,
  imageHeader = false,
  offset = 0,
  imageFactor = 1,
  headerIcon = false,
}) {
  const [scrollValueUpdated, setScrollValueUpdated] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      setScrollValueUpdated(window.scrollY - offset);
    };
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div style={{width:'100%'}} className={styles.animatedHeader}>
      <div className={styles.mainHeader}>
        {mainHeader} {headerIcon && <img src={headerIcon} alt="" />}
      </div>
      {imageHeader && (
        <div
          className={styles.bgHeader}
          style={{
            top: "50%",
            transform: isMobileDevice
              ? `translate3d(25px,0,0)`
              : `translate3d(calc(${offset}px - ${scrollValueUpdated}px), 0%, 0)`,
          }}
        >
          <img
            src={imageHeader}
            alt={mainHeader}
            style={{
              width:mainHeader=="Hot Topics"?"50%":'100%',
              transform: `scale(${isMobileDevice ? imageFactor * 1 : 1})`,
            }}
          />
        </div>
      )}
    </div>
  );
}

export default AnimatedHeader;
